jQuery(document).ready(function($) {
	$('input:disabled').parents('li.choice').css("color", "#DCDAD1");
	$('#live_class_live_type_input').on('change', function(){
    if ($(this).find("#live_class_live_type_true_live").is(':checked') ) {
      $('#video_selector').prop('disabled', true)
      $('#video_selector').prop('required', false)
      $('#live_class_video_id_input').slideUp();
      $('#vod_inputs').show();
    } else {
      $('#video_selector').prop('disabled', false)
      $('#video_selector').prop('required', true)
      $('#live_class_video_id_input').slideDown();
      $('#vod_inputs').hide();
    }
  });
  $('#live_class_live_type_input').trigger('change');

  $('#video_selector').on('change', function () {
    _fetchVideo($(this).val())
  });
})

function _fetchVideo(video_id) {
  var url = `/admin/api/v1/videos/${video_id}`
  $.ajax({
    url: url,
    type: "GET",
    dataType: "json",
    success: function (resp) {
      _fillFields(resp)
      console.log(resp)
    },
    error: function (xhr, status, error) {
      var err = eval("(" + xhr.responseText + ")");
      console.log('SERVER RESPONDED WITH ERROR >>>', err.Message);
    }
  });
};

function _fillFields(video) {
  Object.keys(video).forEach((key) => {
    $(`[id$=${key}]`).val(video[key]).change();
  })
};